import * as React from 'react'
import {Route, Redirect} from 'react-router-dom'
import {isLogin} from '../utils/utils'

import {Header, Navbar} from '../components/header/Header'

import {Footer} from '../components/footer/Footer'

export const PublicRoute = ({component:Component, restricted, ...rest}) => {
    return (
        <Route {...rest} render={ props => (
            isLogin() && restricted ? 
                <Redirect to='/'/> 
            : 
            <> 
                <Header/>
                <Navbar/>
                <Component {...props} />
                <Footer/>
            </>
        )} />
    )
}
